"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import Button from "@/components/ui/button";
import { Dialog, DialogBody, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import Textarea from "@/components/ui/textarea";
import { DocumentSummary } from "@/types/document";
import { useSendDocumentTextMutation } from "@/api/provider/user/patient/document-mutation";
interface SendDocumentTextDialogProps {
  document: DocumentSummary;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Called with the updated document after a successful send. */
  onSent?: (document: DocumentSummary) => void;
}

/**
 * Texts a document to the patient with a custom message. Sending also shares the
 * document to the patient portal (the text is a link into the portal) and saves
 * the message as the patient-facing note.
 */
export default function SendDocumentTextDialog(t0) {
  const $ = _c(36);
  const {
    document,
    open,
    onOpenChange,
    onSent
  } = t0;
  const [message, setMessage] = useState("");
  const sendMutation = useSendDocumentTextMutation();
  let t1;
  if ($[0] !== document.patientMessage || $[1] !== open) {
    t1 = () => {
      if (open) {
        setMessage(document.patientMessage ?? "");
      }
    };
    $[0] = document.patientMessage;
    $[1] = open;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== document.id || $[4] !== document.patientMessage || $[5] !== open) {
    t2 = [open, document.id, document.patientMessage];
    $[3] = document.id;
    $[4] = document.patientMessage;
    $[5] = open;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  useEffect(t1, t2);
  let t3;
  if ($[7] !== document.id || $[8] !== document.patientId || $[9] !== message || $[10] !== onOpenChange || $[11] !== onSent || $[12] !== sendMutation) {
    t3 = () => {
      sendMutation.mutate({
        documentId: document.id,
        patientId: document.patientId,
        message: message.trim()
      }, {
        onSuccess: updated => {
          if (updated) {
            onSent?.(updated);
            onOpenChange(false);
          }
        }
      });
    };
    $[7] = document.id;
    $[8] = document.patientId;
    $[9] = message;
    $[10] = onOpenChange;
    $[11] = onSent;
    $[12] = sendMutation;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  const handleSend = t3;
  let t4;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <DialogHeader><DialogTitle>Send to patient via text</DialogTitle><DialogDescription>Write a message for the patient. We'll text it to them with a secure link to view this document in their portal, and show the message with the document there.</DialogDescription></DialogHeader>;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = e => setMessage(e.target.value);
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== message) {
    t6 = <DialogBody><Textarea value={message} onChange={t5} placeholder={"e.g. Your recent lab results are ready \u2014 everything looks good. Reach out with any questions."} rows={6} /></DialogBody>;
    $[16] = message;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== onOpenChange) {
    t7 = <Button variant="secondary" onClick={() => onOpenChange(false)}>Cancel</Button>;
    $[18] = onOpenChange;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== message) {
    t8 = message.trim();
    $[20] = message;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  const t9 = !t8;
  let t10;
  if ($[22] !== handleSend || $[23] !== sendMutation.isPending || $[24] !== t9) {
    t10 = <Button onClick={handleSend} disabled={t9} isLoading={sendMutation.isPending}>Send text</Button>;
    $[22] = handleSend;
    $[23] = sendMutation.isPending;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== t10 || $[27] !== t7) {
    t11 = <DialogFooter>{t7}{t10}</DialogFooter>;
    $[26] = t10;
    $[27] = t7;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== t11 || $[30] !== t6) {
    t12 = <DialogContent className="max-w-lg">{t4}{t6}{t11}</DialogContent>;
    $[29] = t11;
    $[30] = t6;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== onOpenChange || $[33] !== open || $[34] !== t12) {
    t13 = <Dialog open={open} onOpenChange={onOpenChange}>{t12}</Dialog>;
    $[32] = onOpenChange;
    $[33] = open;
    $[34] = t12;
    $[35] = t13;
  } else {
    t13 = $[35];
  }
  return t13;
}